var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.view.includes('cliente'))?_c('b-row',[_c('b-col',{attrs:{"cols":"12","md":"8","lg":"10"}},[_c('total-previus-sales'),_c('select-client'),_c('alertar-personalizado'),_c('omitir-en-cuenta-corriente'),_c('guardar-como-presupuesto'),_c('discounts'),_c('surchages'),_c('nota-credito')],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }